import React, { useCallback } from 'react';

import MaterialIcon from 'material-icons-react';

import Theme from 'Theme';
import ContextWrapper from '../ContextWrapper';
import Conditional from '../Conditional';
import LoadingSpinner from '../LoadingSpinner';

import { Label, Button, MarginRight } from './Styled';

const PrimaryButton = ({
  icon,
  size,
  label,
  inline,
  border,
  onClick,
  loading,
  children,
  secondary,
  className,
  hoverColor,
  getContext,
  disabled = false,
  color = Theme.brandColor
}) => {
  const onClickHandler = useCallback(() => {
    !disabled && onClick(getContext());
  }, [disabled, onClick, getContext]);

  color = disabled ? Theme.disabled : color;

  return (
    <Button
      size={size}
      color={color}
      inline={inline}
      border={border}
      disabled={disabled}
      secondary={secondary}
      className={className}
      hoverColor={hoverColor}
      onClick={onClickHandler}
    >
      {!secondary && (
        <MarginRight>
          {!loading && icon && (
            <MaterialIcon icon={icon} size={'small'} color={'#fff'} />
          )}
        </MarginRight>
      )}

      <Label
        color={color}
        disabled={disabled}
        secondary={secondary}
        hoverColor={hoverColor}
      >
        <Conditional show={loading}>
          <LoadingSpinner buttonLabel color="#fff" />
        </Conditional>
        <Conditional show={!loading}>{label.toUpperCase()}</Conditional>
      </Label>

      {children}
    </Button>
  );
};

PrimaryButton.defaultProps = {
  label: '',
  onClick: () => null,
  getContext: () => null
};

export default ContextWrapper(PrimaryButton);
